// src/utils/cryptoJS.ts
import CryptoJS from 'crypto-js'
import Cookies from 'js-cookie'

const SECRET_KEY = process.env.VUE_APP_STORAGE_SECRET

export const safeStorage = {

  //加密
  encrypt(val) {
    if (!val) return

    try {
      // 生成16字节随机IV（每次加密不同）
      const iv = CryptoJS.lib.WordArray.random(128 / 8)
      const encrypted = CryptoJS.AES.encrypt(
        CryptoJS.enc.Utf8.parse(val),
        CryptoJS.enc.Utf8.parse(SECRET_KEY),
        {
          iv: iv,
          mode: CryptoJS.mode.CBC,
          padding: CryptoJS.pad.Pkcs7
        }
      )

      // 存储格式：IV十六进制 + 密文
      return iv.toString(CryptoJS.enc.Base64) + ':' + encrypted.toString()
    } catch (error) {
      console.error('Encryption failed:', error)
    }
  },
  decrypt(val) {
    const ciphertextWithIv = val
    if (!ciphertextWithIv) return null

    try {
      // 分离IV和密文
      const [ivHex, ciphertext] = ciphertextWithIv.split(':')
      const iv = CryptoJS.enc.Base64.parse(ivHex)

      const bytes = CryptoJS.AES.decrypt(
        ciphertext,
        CryptoJS.enc.Utf8.parse(SECRET_KEY),
        { iv, mode: CryptoJS.mode.CBC }
      )

      if (bytes.sigBytes <= 0) throw new Error('Invalid ciphertext')
      return bytes.toString(CryptoJS.enc.Utf8)
    } catch (error) {
      console.error('Decryption failed:', error)
      return null
    }
  },
  setSessionStorage(key, val) {
    if (!val) return

    try {
      // 生成16字节随机IV（每次加密不同）
      const iv = CryptoJS.lib.WordArray.random(128 / 8)

      const encrypted = CryptoJS.AES.encrypt(
        CryptoJS.enc.Utf8.parse(val),
        CryptoJS.enc.Utf8.parse(SECRET_KEY),
        {
          iv: iv,
          mode: CryptoJS.mode.CBC,
          padding: CryptoJS.pad.Pkcs7
        }
      )

      // 存储格式：IV十六进制 + 密文
      sessionStorage.setItem(key, iv.toString() + ':' + encrypted.toString())
    } catch (error) {
      console.error('Encryption failed:', error)
    }
  },

  getSessionStorage(key) {
    const ciphertextWithIv = sessionStorage.getItem(key)
    if (!ciphertextWithIv) return null

    try {
      // 分离IV和密文
      const [ivHex, ciphertext] = ciphertextWithIv.split(':')
      const iv = CryptoJS.enc.Hex.parse(ivHex)

      const bytes = CryptoJS.AES.decrypt(
        ciphertext,
        CryptoJS.enc.Utf8.parse(SECRET_KEY),
        { iv, mode: CryptoJS.mode.CBC }
      )

      if (bytes.sigBytes <= 0) throw new Error('Invalid ciphertext')
      return bytes.toString(CryptoJS.enc.Utf8)
    } catch (error) {
      console.error('Decryption failed:', error)
      this.removeLocalStore(key)
      return null
    }
  },

  setCookie(key, val, time) {
    if (!val) return

    try {
      // 生成16字节随机IV（每次加密不同）
      const iv = CryptoJS.lib.WordArray.random(128 / 8)

      const encrypted = CryptoJS.AES.encrypt(
        CryptoJS.enc.Utf8.parse(val),
        CryptoJS.enc.Utf8.parse(SECRET_KEY),
        {
          iv: iv,
          mode: CryptoJS.mode.CBC,
          padding: CryptoJS.pad.Pkcs7
        }
      )

      // 存储格式：IV十六进制 + 密文
      Cookies.set(key, iv.toString() + ':' + encrypted.toString(), { expires: time })
    } catch (error) {
      console.error('Encryption failed:', error)
    }
  },
  getCookie(key) {
    const ciphertextWithIv = Cookies.get(key)
    if (!ciphertextWithIv) return null

    try {
      // 分离IV和密文
      const [ivHex, ciphertext] = ciphertextWithIv.split(':')
      const iv = CryptoJS.enc.Hex.parse(ivHex)

      const bytes = CryptoJS.AES.decrypt(
        ciphertext,
        CryptoJS.enc.Utf8.parse(SECRET_KEY),
        { iv, mode: CryptoJS.mode.CBC }
      )

      if (bytes.sigBytes <= 0) throw new Error('Invalid ciphertext')
      return bytes.toString(CryptoJS.enc.Utf8)
    } catch (error) {
      console.error('Decryption failed:', error)
      Cookies.remove(key)
      return null
    }
  },

  removeSessionStorage(key) {
    sessionStorage.removeItem(key)
  },
  removeCookie(key) {
    Cookies.remove(key)
  }
}